/*
    © 2023 EcomGraduates.com
    https://www.ecomgraduates.com
*/

// Refresh cart contents (offcanvas cart, cart page, count badges, etc)
window.refreshCartContents = async (response) => {
    console.log(response)

    const offcanvasCart = document.querySelector('#offcanvas-cart')
    const cartPage = document.querySelector('#cart')

    offcanvasCart?.classList.add('loading')
    cartPage?.classList.add('loading')

    const newResponse = await fetch(window.location.href)
    const text = await newResponse.text()
    const newDocument = new DOMParser().parseFromString(text, 'text/html')

    offcanvasCart?.querySelector('.offcanvas-body')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
    offcanvasCart?.querySelector('.offcanvas-footer')
        .replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-footer'))
    cartPage?.replaceWith(newDocument.querySelector('#cart'))

    document.querySelectorAll('.cart-count-badge').forEach((badge) => {
        badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
        badge.removeAttribute('hidden')
    })

    offcanvasCart?.classList.remove('loading')
    cartPage?.classList.remove('loading')

    window.dispatchEvent(new Event('updated.ecomify.cart'))

    if (response.ok) {
        if (response.url.includes('add.js')) {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-add').removeAttribute('hidden')

            const data = await response.json()

            if (data.items?.length > 1) {
                const elemAlertItemsAdded = offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-items-added]')

                elemAlertItemsAdded.textContent = elemAlertItemsAdded.textContent.replace('[count]', data.items.length)
                elemAlertItemsAdded.removeAttribute('hidden')
            } else {
                offcanvasCart?.querySelector('#offcanvas-cart-alert-add [data-alert-item-added]')
                    .removeAttribute('hidden')
            }
        } else {
            offcanvasCart?.querySelector('#offcanvas-cart-alert-updated').removeAttribute('hidden')
        }
    } else {
        const data = await response.json()
        const alert = document.querySelector('#offcanvas-cart-alert-error')
        alert.querySelector('span').textContent = `${data.message} - ${data.description}`
        alert.removeAttribute('hidden')
    }
}

// Quantity Inputs
window.onChangeCartQty = async (input) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: input.dataset.lineItemKey,
            quantity: input.value
        })
    })
    window.refreshCartContents(response)
}

// Remove Buttons
window.onRemoveCartItem = async (btn) => {
    const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            id: btn.dataset.lineItemKey,
            quantity: 0
        })
    })
    window.refreshCartContents(response)
}

// Cart note - Show button on keydown
window.showNoteButton = (input) => {
    input.closest('#cart-note').querySelector('button').removeAttribute('hidden')
}

// Cart note - Save note via ajax
window.onSaveCartNote = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const note = btn.closest('#cart-note').querySelector('[name="note"]').value

    await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
    })

    btn.innerHTML = `✓ <span class="visually-hidden">${btn.dataset.textNoteSaved}</span>`

    setTimeout(() => {
        btn.innerHTML = btn.dataset.textBtnSave
    }, 4000)
}

// Checkout button - indicate loading on click
window.onClickCheckoutBtn = (btn) => {
    btn.style.height = btn.clientHeight + 'px'
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1.2rem; height: 1.2rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `
}

// Cart Goal - Animate width
const initCartGoal = () => {
    const progressBar = document.querySelector('#cart-goal .progress-bar')
    if (progressBar) {
        setTimeout(() => {
            progressBar.style.width = progressBar.dataset.width
        }, 250)
    }
}
initCartGoal()

window.addEventListener('updated.ecomify.cart', () => {
    initCartGoal()
})

// Summary card on the cart page - sticky on desktop
const initStickySummaryCard = () => {
    const card = document.querySelector('#cart-summary')

    if (!card) return

    if (window.matchMedia('max-width: 991px').matches) return

    const navbarHeight = document.querySelector('[id*="__navbar"].sticky-top')?.clientHeight || 0
    const announcementBarHeight = document.querySelector('[id*="__announcement-bar"].sticky-top')?.clientHeight || 0

    card.style.position = 'sticky'
    card.style.top = `${navbarHeight + announcementBarHeight + 20}px`
}
initStickySummaryCard()

window.addEventListener('updated.ecomify.cart', () => {
    initStickySummaryCard()
})

// Generate Shipping rates
// https://shopify.dev/docs/api/ajax/reference/cart#generate-shipping-rates
window.generateShippingRates = async (btn) => {
    btn.innerHTML = `
        <div class="spinner-border spinner-border-sm" role="status" style="width: 1rem; height: 1rem">
            <span class="visually-hidden">Loading...</span>
        </div>
    `

    const modal = document.querySelector('#shipping-rates-modal')

    modal.querySelector('#shipping-rates-modal-alert-danger').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-danger').setAttribute('hidden', 'hidden')
    modal.querySelector('#shipping-rates-modal-alert-warning').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-warning').setAttribute('hidden', 'hidden')
    modal.querySelector('#shipping-rates-modal-alert-success').innerHTML = ''
    modal.querySelector('#shipping-rates-modal-alert-success').setAttribute('hidden', 'hidden')

    const country = modal.querySelector('#shipping-rates-modal-country').value
    const province = modal.querySelector('#shipping-rates-modal-province').value
    const zip = modal.querySelector('#shipping-rates-modal-zip').value

    const prepareResponse = await fetch(`/cart/prepare_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`, {
        method: 'POST'
    })
    console.log(prepareResponse)

    if (prepareResponse.ok) {
        const asyncRespose = await fetch(`/cart/async_shipping_rates.json?shipping_address[zip]=${zip}&shipping_address[country]=${country}&shipping_address[province]=${province}`)
        console.log(asyncRespose)

        const data = await asyncRespose.json()
        console.log(data)

        let html = ''

        if (data.shipping_rates.length) {
            data.shipping_rates.forEach(elem => {
                html += `
                    <li>
                        <strong>${elem.presentment_name}</strong>: ${elem.price} ${elem.currency}
                    </li>
                `
            })

            modal.querySelector('#shipping-rates-modal-alert-success').innerHTML = `
                <ul class="ps-5 mb-0">
                    ${html}
                </ul>
            `
            modal.querySelector('#shipping-rates-modal-alert-success').removeAttribute('hidden')
        } else {
            modal.querySelector('#shipping-rates-modal-alert-warning').innerHTML = `
                <p class="mb-0">
                    ${modal.dataset.textNoResults}
                </p>
            `
            modal.querySelector('#shipping-rates-modal-alert-warning').removeAttribute('hidden')
        }
    } else {
        const data = await prepareResponse.json()
        console.log(data)

        let html = ''

        for (const [key, value] of Object.entries(data)) {
            html += `
                <li>
                    <strong>${key}</strong>: ${value.toString()}
                </li>
            `
        }

        modal.querySelector('#shipping-rates-modal-alert-danger').innerHTML = `
            <ul class="ps-5 mb-0">
                ${html}
            </ul>
        `
        modal.querySelector('#shipping-rates-modal-alert-danger').removeAttribute('hidden')
    }

    btn.innerHTML = btn.dataset.text
}

/*
    Quick Add Button functionality
*/
window.onQuickAdd = async (btn) => {
    const wrapper = btn.closest('.quick-add-wrapper');
    const variantId = wrapper.dataset.variantId;
    const iconPlus = btn.querySelector('.quick-add-icon-plus');
    const spinner = btn.querySelector('.quick-add-spinner');

    // Show loading state
    iconPlus.setAttribute('hidden', '');
    spinner.removeAttribute('hidden');
    btn.disabled = true;

    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        });

        if (response.ok) {
            // Switch to quantity mode
            wrapper.setAttribute('data-qty-mode', 'true');
            wrapper.querySelector('.quick-add-qty-wrapper').removeAttribute('hidden');
            wrapper.querySelector('.quick-add-qty-count').textContent = '1';

            // Store the line item key for later updates
            const data = await response.json();
            wrapper.dataset.lineItemKey = data.key;

            // Refresh cart contents
            window.refreshCartContents(response);
        } else {
            // Reset button on error
            iconPlus.removeAttribute('hidden');
            spinner.setAttribute('hidden', '');
            btn.disabled = false;

            const data = await response.json();
            console.error('Error adding to cart:', data);
        }
    } catch (error) {
        console.error('Error:', error);
        iconPlus.removeAttribute('hidden');
        spinner.setAttribute('hidden', '');
        btn.disabled = false;
    }
};

window.onQuickAddQty = async (btn, mode) => {
    const wrapper = btn.closest('.quick-add-wrapper');
    const variantId = wrapper.dataset.variantId;
    const countEl = wrapper.querySelector('.quick-add-qty-count');
    let currentQty = parseInt(countEl.textContent);

    // Calculate new quantity
    const newQty = mode === 'plus' ? currentQty + 1 : currentQty - 1;

    // Disable buttons during update
    wrapper.querySelectorAll('.quick-add-qty-btn').forEach(b => b.disabled = true);

    try {
        if (newQty <= 0) {
            // Remove from cart - find the line item key
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            const lineItem = cartData.items.find(item => item.variant_id === parseInt(variantId));

            if (lineItem) {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: lineItem.key,
                        quantity: 0
                    })
                });

                if (response.ok) {
                    // Switch back to plus button mode
                    wrapper.removeAttribute('data-qty-mode');
                    wrapper.querySelector('.quick-add-qty-wrapper').setAttribute('hidden', '');
                    wrapper.querySelector('.quick-add-btn').disabled = false;
                    wrapper.querySelector('.quick-add-icon-plus').removeAttribute('hidden');
                    wrapper.querySelector('.quick-add-spinner').setAttribute('hidden', '');

                    window.refreshCartContents(response);
                }
            }
        } else {
            // Update quantity
            const cartResponse = await fetch('/cart.js');
            const cartData = await cartResponse.json();
            const lineItem = cartData.items.find(item => item.variant_id === parseInt(variantId));

            if (lineItem) {
                const response = await fetch('/cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: lineItem.key,
                        quantity: newQty
                    })
                });

                if (response.ok) {
                    countEl.textContent = newQty;
                    window.refreshCartContents(response);
                }
            } else {
                // Item not in cart, add it
                const response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: variantId,
                        quantity: newQty
                    })
                });

                if (response.ok) {
                    countEl.textContent = newQty;
                    window.refreshCartContents(response);
                }
            }
        }
    } catch (error) {
        console.error('Error:', error);
    }

    // Re-enable buttons
    wrapper.querySelectorAll('.quick-add-qty-btn').forEach(b => b.disabled = false);
};

// Initialize quick add buttons based on cart contents
window.initQuickAddButtons = async () => {
    const quickAddWrappers = document.querySelectorAll('.quick-add-wrapper');
    if (quickAddWrappers.length === 0) return;

    try {
        const response = await fetch('/cart.js');
        const cartData = await response.json();

        quickAddWrappers.forEach(wrapper => {
            const variantId = parseInt(wrapper.dataset.variantId);
            const lineItem = cartData.items.find(item => item.variant_id === variantId);

            if (lineItem && lineItem.quantity > 0) {
                // Show quantity mode
                wrapper.setAttribute('data-qty-mode', 'true');
                wrapper.querySelector('.quick-add-qty-wrapper').removeAttribute('hidden');
                wrapper.querySelector('.quick-add-qty-count').textContent = lineItem.quantity;
            } else {
                // Show plus button
                wrapper.removeAttribute('data-qty-mode');
                wrapper.querySelector('.quick-add-qty-wrapper').setAttribute('hidden', '');
            }
        });
    } catch (error) {
        console.error('Error initializing quick add buttons:', error);
    }
};

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
    window.initQuickAddButtons();
});

// Re-initialize after cart updates
window.addEventListener('updated.ecomify.cart', () => {
    window.initQuickAddButtons();
});
